import { render } from "./Home.vue?vue&type=template&id=3bd6e66e&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=3bd6e66e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eszti-isti.donko.hu/eszti-isti.donko.hu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd6e66e"]])

export default __exports__